import React from "react";
import logo from "../../../assets/logo.png";
import "./style.css";

function Header() {
  return (
    <header className="app-header">
      <img src={logo} alt="UN Logo" className="header-logo" />
      <div className="header-text">
        <div className="header-subtitle">Security Council</div>
        <div className="header-subtitle">
          Consolidated List Search
        </div>
      </div>
    </header>
  );
}

export default Header;
